<template>
  <v-container style="height: auto !important;">
    <v-data-table
        :headers="headers"
        :items="products"
        class="elevation-1"
        :loading="(products.length === 0 && isLoading)"
        loading-text="Loading... Please wait"
    >
      <template v-slot:item.url="{ item }">
        <v-img
            max-height="50"
            max-width="50"
            :src="item.url"
        ></v-img>
      </template>
      <template v-slot:top>
        <v-toolbar
            flat
        >
          <v-toolbar-title>Products</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog
              v-model="dialog"
              max-width="500px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="resetForm"

              >
                New Product
              </v-btn>
            </template>
            <v-form ref="form"
                    v-model="valid"
                    lazy-validation
            >
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>


                  <v-container style="height: auto !important;">
                    <v-row>
                      <v-col
                          md="12"
                          sm="12"
                          cols="12"
                      >
                        <v-text-field
                            v-model="editedProduct.title"
                            label="Product name"
                            :rules="titleRules"
                            required
                        ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                          sm="12"
                          md="12"
                      >
                        <v-text-field
                            v-model="editedProduct.price"
                            label="Price"
                            :rules="priceRules"
                            required
                        ></v-text-field>
                      </v-col>
                      <v-col
                          md="12"
                          sm="12"
                          cols="12"

                      >
                        <v-file-input
                            show-size
                            v-model="editedProduct.image"
                            truncate-length="25"
                            :rules="(formTitle === 'New Product')? imageRules: []"
                            required
                        ></v-file-input>
                      </v-col>
                      <v-col
                          md="12"
                          sm="12"
                          cols="12"
                      >
                        <v-textarea
                            v-model="editedProduct.description"
                            label="Description"
                            :rules="descriptionRules"
                            required
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>

                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                      color="blue darken-1"
                      text
                      @click="close"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                      color="blue darken-1"
                      text
                      @click="save"
                      :disabled="!valid"

                  >
                    Save
                  </v-btn>
                </v-card-actions>

              </v-card>
            </v-form>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline">Are you sure you want to delete this product?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
            small
            @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn
            dark
            @click="initialize"
        >
          Reset
        </v-btn>
      </template>
    </v-data-table>

  </v-container>
</template>

<script>
import {deleteProduct, fetchProducts, saveProduct, updateProduct} from "@/shared/productsService";
import constants from "@/api/constants";

export default {
  name: "products",
  data: () => ({
    valid: false,
    dialog: false,
    dialogDelete: false,
    isLoading: true,
    headers: [
      {
        text: '#',
        value: 'id',
      },
      {text: 'Product Name', value: 'title'},
      {text: 'Price', value: 'price'},
      {text: 'Picture', value: 'url'},
      {text: 'Actions', value: 'actions', sortable: false},
    ],
    products: [],
    editedIndex: -1,
    titleRules: [
      v => !!v || 'Name is required',
    ],
    imageRules: [
      v => !!v || 'Image is required',
    ],
    descriptionRules: [
      v => !!v || 'Description is required',
    ],
    priceRules: [
      v => (!isNaN(v) && v > 0) || 'Price is required',
    ],
    editedProduct: {
      id: 0,
      title: '',
      description: '',
      image: null,
      price: 0,
    },
    defaultProduct: {
      id: 0,
      title: '',
      description: '',
      image: null,
      price: 0,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Product' : 'Edit Product'
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    },
  },

  async created() {
    await this.initialize()
  },

  methods: {
    changeRule() {
      this.imageRules = [
        v => !!v || 'Image is required',
      ];
    },
    async initialize() {
      var response = await fetchProducts();
      this.products = response.data;
      if (this.products.length === 0) {
        this.isLoading = false;
      }
      this.products = response.data.map(pro => {
        return {...pro, url: `${constants.host}api/media/${pro['media'][0]['id']}`};
      });
    },

    editItem(item) {

      this.editedIndex = this.products.indexOf(item)
      this.editedProduct = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem(item) {
      this.editedIndex = this.products.indexOf(item)
      this.editedProduct = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm() {
      // delete product
      const editedIndex = this.editedIndex;
      deleteProduct(this.products[editedIndex]).then(() => {
        this.products.splice(editedIndex, 1);
      });
      this.closeDelete()
    },

    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedProduct = Object.assign({}, this.defaultProduct)
        this.editedIndex = -1
      })
    },

    closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedProduct = Object.assign({}, this.defaultProduct)
        this.editedIndex = -1
      })
    },
    resetForm() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.editedProduct = {
        id: 0,
        title: '',
        description: '',
        image: null,
        price: 0,
      };
    },
    save() {
      const editedIndex = this.editedIndex;
      const editedProduct = this.editedProduct;
      let form_data = new FormData();
      for (var key in this.editedProduct) {
        form_data.append(key, this.editedProduct[key]);
      }

      if (this.editedIndex > -1) {
        // update
        if (form_data.get('image') == "null")
          form_data.delete('image');
        updateProduct(form_data).then(() => {
          Object.assign(this.products[editedIndex], editedProduct)
          this.$refs.form.resetValidation();
          this.$refs.form.reset();
        });
      } else {
        // save
        if (this.$refs.form.validate()) {
          saveProduct(form_data).then(response => {
            this.products.push(response.data)
            this.$refs.form.resetValidation();
            this.$refs.form.reset();
          });
        }
      }
      this.close()

    },
  },
}
</script>

<style scoped>

</style>
